import { render, staticRenderFns } from "./ProductLinkTabs.vue?vue&type=template&id=52d9fabd&scoped=true"
import script from "./ProductLinkTabs.vue?vue&type=script&lang=ts"
export * from "./ProductLinkTabs.vue?vue&type=script&lang=ts"
import style0 from "./ProductLinkTabs.vue?vue&type=style&index=0&id=52d9fabd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d9fabd",
  null
  
)

export default component.exports